export default "__VITE_ASSET__Cq2FiMO2__"